export const fullHexagrams = [
  {
    index: 1,
    name_ko: '중천건',
    name_zh: '重天乾',
    gua: {
      zh: '乾, 元亨利貞',
      ko: '건, 원형리정',
    },
    lines: {
      용구: {
        zh: '見羣龍. 无首, 吉.',
        ko: '견군룡, 무수, 길.',
      },
      상효: {
        zh: '亢龍有悔.',
        ko: '항룡유회.',
      },
      '5효': {
        zh: '飛龍在天, 利見大人.',
        ko: '비룡재천, 리견대인.',
      },
      '4효': {
        zh: '或躍在淵, 无咎.',
        ko: '혹약재연, 무구.',
      },
      '3효': {
        zh: '君子終日乾乾, 夕惕若, 厲无咎.',
        ko: '군자종일건건, 석척약, 려무구.',
      },
      '2효': {
        zh: '見龍在田, 利見大人.',
        ko: '현룡재전, 리견대인.',
      },
      초효: {
        zh: '潛龍勿用.',
        ko: '잠룡물용.',
      },
    },
  },
  {
    index: 2,
    name_ko: '중지곤',
    name_zh: '重地坤',
    gua: {
      zh: '坤, 元亨, 利牝馬之貞. 君子有攸往, 先迷後得主. 利西南得朋, 東北喪朋. 安貞吉.',
      ko: '곤, 원형, 리빈마지정. 군자유유왕, 선미후득주. 리서남득붕, 동북상붕. 안정길.',
    },
    lines: {
      용육: {
        zh: '利永貞.',
        ko: '리영정.',
      },
      상효: {
        zh: '龍戰于野, 其血玄黃.',
        ko: '용전우야, 기혈현황.',
      },
      '5효': {
        zh: '黃裳, 元吉.',
        ko: '황리, 원길.',
      },
      '4효': {
        zh: '括囊, 无咎无譽.',
        ko: '괄낭, 무구무예.',
      },
      '3효': {
        zh: '含章可貞, 或從王事, 无成有終.',
        ko: '함장가정, 혹종왕사, 무성유종.',
      },
      '2효': {
        zh: '直方大, 不習无不利.',
        ko: '직방대, 불습무불리.',
      },
      초효: {
        zh: '履霜, 堅冰至.',
        ko: '리상, 견빙지.',
      },
    },
  },
  {
    index: 3,
    name_ko: '수뢰둔',
    name_zh: '水雷屯',
    gua: {
      zh: '屯, 元亨, 利貞. 勿用有攸往, 利建侯.',
      ko: '둔, 원형 리정. 물용유유왕, 리건후.',
    },
    lines: {
      상효: {
        zh: '乘馬班如, 泣血漣如.',
        ko: '승마반여, 읍혈연여.',
      },
      '5효': {
        zh: '屯其膏. 小貞吉, 大貞凶.',
        ko: '둔기고. 소정길, 대정흉.',
      },
      '4효': {
        zh: '乘馬班如, 求婚媾, 往吉, 无不利.',
        ko: '승마반여, 구혼구, 왕길, 무불리.',
      },
      '3효': {
        zh: '卽鹿无虞, 惟入于林中, 君子幾, 不如舍, 往吝.',
        ko: '즉록무우, 유입유림중, 군자기, 불여사, 왕린.',
      },
      '2효': {
        zh: '屯如邅如. 乘馬班如. 匪寇婚媾. 女子貞不字, 十年乃字.',
        ko: '둔여전여. 승마반여. 비구혼구. 여자정불자, 십년내자.',
      },
      초효: {
        zh: '磐桓, 利居貞, 利建侯.',
        ko: '반환, 리거정, 리건후.',
      },
    },
  },
  {
    index: 4,
    name_ko: '산수몽',
    name_zh: '山水蒙',
    gua: {
      zh: '蒙, 亨. 匪我求童蒙, 童蒙求我, 初筮告, 再三瀆, 瀆則不告. 利貞.',
      ko: '몽, 형. 비아구동몽, 동몽구아, 초서고, 재삼독, 독즉불고. 리정.',
    },
    lines: {
      상효: {
        zh: '擊蒙, 不利爲寇, 利禦寇.',
        ko: '격몽, 불리위구, 리어구.',
      },
      '5효': {
        zh: '童蒙, 吉.',
        ko: '동몽, 길.',
      },
      '4효': {
        zh: '困蒙, 吝.',
        ko: '곤몽, 린.',
      },
      '3효': {
        zh: '勿用取女, 見金夫, 不有躬, 无攸利.',
        ko: '물용취녀, 견급부, 불유궁, 무유리.',
      },
      '2효': {
        zh: '包蒙吉. 納婦吉, 子克家.',
        ko: '포몽길, 납부길, 자극가.',
      },
      초효: {
        zh: '發蒙, 利用刑人, 用說桎梏以往吝.',
        ko: '발몽, 리용형인, 용탈질곡이왕린.',
      },
    },
  },
  {
    index: 5,
    name_ko: '수천수',
    name_zh: '水天需',
    gua: {
      zh: '需, 有孚, 光亨, 貞吉. 利涉大川.',
      ko: '수, 유부, 광형, 정길. 리섭대천.',
    },
    lines: {
      상효: {
        zh: '入于穴, 有不速之客三人來, 敬之, 終吉.',
        ko: '입우혈, 유불속지객삼인래, 경지, 무구.',
      },
      '5효': {
        zh: '需于酒食, 貞吉.',
        ko: '수우주식, 정길.',
      },
      '4효': {
        zh: '需于血, 出自穴.',
        ko: '수우혈, 출자혈.',
      },
      '3효': {
        zh: '需于泥, 致寇至.',
        ko: '수우니, 치구지.',
      },
      '2효': {
        zh: '需于沙, 小有言, 終吉.',
        ko: '수우사, 소유언, 종길.',
      },
      초효: {
        zh: '需于郊, 利用恒, 无咎.',
        ko: '수우교, 리용항, 무구.',
      },
    },
  },
  {
    index: 6,
    name_ko: '천수송',
    name_zh: '天水訟',
    gua: {
      zh: '訟, 有孚窒惕, 中吉終凶, 利見大人, 不利涉大川.',
      ko: '송, 유부질척. 중길종흉, 리견대인, 불리섭대천.',
    },
    lines: {
      상효: {
        zh: '或錫之鞶帶, 終朝三褫之.',
        ko: '혹석지반대, 종조삼치지.',
      },
      '5효': {
        zh: '訟, 元吉.',
        ko: '송, 원길.',
      },
      '4효': {
        zh: '不克訟, 復卽命, 渝, 安貞吉.',
        ko: '불극송, 복즉명, 투, 안정길.',
      },
      '3효': {
        zh: '食舊德 貞厲 終吉, 或從王事, 无成.',
        ko: '식구덕 정려 종길. 혹종왕사, 무성.',
      },
      '2효': {
        zh: '不克訟, 歸而逋, 其邑人三百戶, 无眚.',
        ko: '불극송, 귀이포, 기읍인삼백호, 무생.',
      },
      초효: {
        zh: '不永所事, 小有言, 終吉.',
        ko: '불영소사, 소유언, 종길.',
      },
    },
  },
  {
    index: 7,
    name_ko: '지수사',
    name_zh: '地水師',
    gua: {
      zh: '師, 貞. 丈人,  吉无咎.',
      ko: '사, 정. 장인,  길무구.',
    },
    lines: {
      상효: {
        zh: '大君有命, 開國承家, 小人勿用.',
        ko: '대군유명, 개국승가, 소인물용.',
      },
      '5효': {
        zh: '田有禽, 利執言, 无咎, 長子帥師, 弟子輿尸, 貞凶.',
        ko: '전유금, 리집언, 무구. 장자솔사, 제자여시, 정흉.',
      },
      '4효': {
        zh: '師左次, 无咎.',
        ko: '사좌차, 무구.',
      },
      '3효': {
        zh: '師或輿尸, 凶.',
        ko: '사혹여시, 흉.',
      },
      '2효': {
        zh: '在師中 吉无咎, 王三錫命.',
        ko: '사재중, 길무구, 왕삼석명.',
      },
      초효: {
        zh: '師出以律, 否臧凶.',
        ko: '사출이율, 비장흉.',
      },
    },
  },
  {
    index: 8,
    name_ko: '수지비',
    name_zh: '水地比',
    gua: {
      zh: '比, 吉. 原筮, 元永貞, 无咎. 不寧方來, 後夫凶.',
      ko: '비, 길. 원서, 원영정, 무구. 불녕방래, 후부흉.',
    },
    lines: {
      상효: {
        zh: '比之无首, 凶.',
        ko: '비지무수, 흉.',
      },
      '5효': {
        zh: '顯比, 王用三驅, 失前禽, 邑人不誡, 吉.',
        ko: '현비, 왕용삼구, 실전금, 읍인불계, 길.',
      },
      '4효': {
        zh: '外比之, 貞吉.',
        ko: '외비지, 정길.',
      },
      '3효': {
        zh: '比之匪人.',
        ko: '비지비인.',
      },
      '2효': {
        zh: '比之自內, 貞吉.',
        ko: '비지자내, 정길.',
      },
      초효: {
        zh: '有孚比之, 无咎, 有孚盈缶, 終來有它吉.',
        ko: '유부비지, 무구. 유부영부, 종래유타길.',
      },
    },
  },
  {
    index: 9,
    name_ko: '풍천소축',
    name_zh: '風天小畜',
    gua: {
      zh: '小畜, 亨. 密雲不雨, 自我西郊.',
      ko: '소축, 형. 밀운불우, 자아서교.',
    },
    lines: {
      상효: {
        zh: '旣雨旣處 尙德載. 婦貞慮 月幾望 君子征凶.',
        ko: '기우기처 상덕재. 부정려 월기망 군자정흉.',
      },
      '5효': {
        zh: '有孚攣如, 富以其隣.',
        ko: '유부연여, 부이기린.',
      },
      '4효': {
        zh: '有孚, 血去惕出, 無咎.',
        ko: '유부, 혈거척출, 무구.',
      },
      '3효': {
        zh: '輿說輻, 夫妻反目.',
        ko: '여탈복, 부처반목.',
      },
      '2효': {
        zh: '牽復, 吉.',
        ko: '견복, 길.',
      },
      초효: {
        zh: '復自道, 何其咎. 吉.',
        ko: '복자도, 하기구. 길.',
      },
    },
  },
  {
    index: 10,
    name_ko: '천택리',
    name_zh: '天澤履',
    gua: {
      zh: '履虎尾, 不咥人, 亨.',
      ko: '리호미, 불질인, 형.',
    },
    lines: {
      상효: {
        zh: '視履考祥, 其旋元吉.',
        ko: '시리고상, 기선원길.',
      },
      '5효': {
        zh: '夬履, 貞厲.',
        ko: '쾌리, 정려.',
      },
      '4효': {
        zh: '履虎尾, 愬愬, 終吉.',
        ko: '리호미, 색색, 종길.',
      },
      '3효': {
        zh: '眇能視, 跛能履, 履虎尾咥人, 凶, 武人爲于大君.',
        ko: '묘능시, 파능리, 리호미질인, 흉. 무인위우대군.',
      },
      '2효': {
        zh: '履道坦坦, 幽人貞吉.',
        ko: '리도탄탄, 유인정길.',
      },
      초효: {
        zh: '素履, 往无咎.',
        ko: '소리, 왕무구.',
      },
    },
  },
  {
    index: 11,
    name_ko: '지천태',
    name_zh: '地天泰',
    gua: {
      zh: '泰, 小往大来，吉，亨.',
      ko: '태, 소왕대래, 길. 형.',
    },
    lines: {
      상효: {
        zh: '城復于隍, 勿用師. 自邑告命, 貞吝.',
        ko: '성복우황, 물용사. 자읍고명, 정린.',
      },
      '5효': {
        zh: '帝乙歸妹, 以祉元吉.',
        ko: '제을귀매, 이지원길.',
      },
      '4효': {
        zh: '翩翩, 不富以其鄰. 不戒以孚.',
        ko: '편편, 불부이기린. 불계이부.',
      },
      '3효': {
        zh: '无平不陂, 无往不復, 艱貞无咎. 勿恤其孚, 于食有福.',
        ko: '무평불피, 무왕불복, 간정무구. 물휼기부, 우식유복.',
      },
      '2효': {
        zh: '包荒, 用馮河, 不遐遺, 朋亡, 得尙于中行.',
        ko: '포황, 용빙하, 불하유, 붕망, 득상우중행.',
      },
      초효: {
        zh: '拔茅茹, 以其彙, 征吉.',
        ko: '발모여, 이기휘, 정길.',
      },
    },
  },
  {
    index: 12,
    name_ko: '천지비',
    name_zh: '天地否',
    gua: {
      zh: '否之匪人, 不利君子貞, 大往小來.',
      ko: '비지비인, 불리군자정, 대왕소래.',
    },
    lines: {
      상효: {
        zh: '傾否, 先否後喜.',
        ko: '경비, 선비후희.',
      },
      '5효': {
        zh: '休否, 大人吉, 其亡其亡, 繫于苞桑.',
        ko: '휴비, 대인길, 기망기망, 계우포상.',
      },
      '4효': {
        zh: '有命无咎, 疇離祉.',
        ko: '유명무구, 주리지.',
      },
      '3효': {
        zh: '包羞.',
        ko: '포수',
      },
      '2효': {
        zh: '包承, 小人吉, 大人否, 亨.',
        ko: '포승, 소인길, 대인비, 형.',
      },
      초효: {
        zh: '拔茅茹, 以其彙, 貞吉, 亨.',
        ko: '발모여, 이기휘, 정길. 형.',
      },
    },
  },
  {
    index: 13,
    name_ko: '천화동인',
    name_zh: '天火同人',
    gua: {
      zh: '同人于野, 亨, 利涉大川, 利君子貞.',
      ko: '동인우야, 형, 리섭대천, 리군자정.',
    },
    lines: {
      상효: {
        zh: '同人于郊, 无悔.',
        ko: '동인우교, 무회.',
      },
      '5효': {
        zh: '同人, 先號咷而後笑, 大師克相遇.',
        ko: '동인, 선호도이후소, 대사극상우.',
      },
      '4효': {
        zh: '乘其墉, 弗克攻, 吉.',
        ko: '승기용, 불극공, 길.',
      },
      '3효': {
        zh: '伏戎于莽, 升其高陵, 三歲不興.',
        ko: '복융우망, 승기고릉, 삼세불흥.',
      },
      '2효': {
        zh: '同人于宗, 吝.',
        ko: '동인우종, 린.',
      },
      초효: {
        zh: '同人于門, 无咎.',
        ko: '동인우문, 무구.',
      },
    },
  },
  {
    index: 14,
    name_ko: '화천대유',
    name_zh: '火天大有',
    gua: {
      zh: '大有, 元亨.',
      ko: '대유, 원형.',
    },
    lines: {
      상효: {
        zh: '自天祐之, 吉无不利.',
        ko: '자천우지, 길무불리.',
      },
      '5효': {
        zh: '厥孚交如, 威如, 吉.',
        ko: '궐부교여, 위여, 길.',
      },
      '4효': {
        zh: '匪其彭, 无咎.',
        ko: '비기팽, 무구.',
      },
      '3효': {
        zh: '公用亨于天子, 小人弗克.',
        ko: '공용향우천자, 소인불극.',
      },
      '2효': {
        zh: '大車以載, 有攸往, 无咎.',
        ko: '대차이재, 유유왕, 무구.',
      },
      초효: {
        zh: '无交害, 匪咎, 艱則无咎.',
        ko: '무교해, 비구, 간즉무구.',
      },
    },
  },
  {
    index: 15,
    name_ko: '지산겸',
    name_zh: '地山謙',
    gua: {
      zh: '謙, 亨. 君子有終.',
      ko: '겸, 형. 군자유종.',
    },
    lines: {
      상효: {
        zh: '鳴謙, 利用行師, 征邑國.',
        ko: '명겸, 리용행사, 정읍국.',
      },
      '5효': {
        zh: '不富以其鄰, 利用侵伐, 无不利.',
        ko: '불부이기린, 리용침벌, 무불리.',
      },
      '4효': {
        zh: '无不利, 撝謙.',
        ko: '무불리, 휘겸.',
      },
      '3효': {
        zh: '勞謙, 君子有終, 吉.',
        ko: '노겸, 군자유종, 길.',
      },
      '2효': {
        zh: '鳴謙, 貞吉.',
        ko: '명겸, 정길.',
      },
      초효: {
        zh: '謙謙君子, 用涉大川, 吉.',
        ko: '겸겸군자, 용섭대천, 길.',
      },
    },
  },
  {
    index: 16,
    name_ko: '뇌지예',
    name_zh: '雷地豫',
    gua: {
      zh: '豫, 利建侯行師.',
      ko: '예, 리건후행사.',
    },
    lines: {
      상효: {
        zh: '冥豫. 成有渝 無咎.',
        ko: '명예, 성유투 무구.',
      },
      '5효': {
        zh: '貞. 疾恒不死.',
        ko: '정. 질항불사.',
      },
      '4효': {
        zh: '由豫, 大有得. 勿疑, 朋盍簪.',
        ko: '유예, 대유득. 불의, 붕합잠.',
      },
      '3효': {
        zh: '盱豫悔 遲有悔.',
        ko: '우예회 지유회.',
      },
      '2효': {
        zh: '介于石 不終日 貞吉.',
        ko: '개우석, 불종일, 정길.',
      },
      초효: {
        zh: '鳴豫 凶.',
        ko: '명예, 흉.',
      },
    },
  },
  {
    index: 17,
    name_ko: '택뢰수',
    name_zh: '澤雷隨',
    gua: {
      zh: '隨, 元亨利貞, 无咎.',
      ko: '수, 원형리정, 무구.',
    },
    lines: {
      상효: {
        zh: '句係之, 乃從維之. 王用亨于西山.',
        ko: '구계지, 내종유지. 왕용향우서산.',
      },
      '5효': {
        zh: '孚于嘉, 吉.',
        ko: '부우가, 길.',
      },
      '4효': {
        zh: '隨有獲, 貞凶. 有孚在道以明 何咎.',
        ko: '수유획, 정흉. 유부재도이명 하구.',
      },
      '3효': {
        zh: '係丈夫, 失小子. 隨有求得 利居貞.',
        ko: '계장부, 실소자. 수유구득 리거정.',
      },
      '2효': {
        zh: '係小子, 失丈夫.',
        ko: '계소자, 실장부.',
      },
      초효: {
        zh: '官有渝 貞吉. 出門交 有功.',
        ko: '관유투 정길. 출문교 유공.',
      },
    },
  },
  {
    index: 18,
    name_ko: '산풍고',
    name_zh: '山風蠱',
    gua: {
      zh: '蠱, 元亨, 利涉大川. 先甲三日, 後甲三日.',
      ko: '고, 원형. 리섭대천. 선갑삼일, 후갑삼일.',
    },
    lines: {
      상효: {
        zh: '不事王侯, 高尙其事.',
        ko: '불사왕후, 고상기사.',
      },
      '5효': {
        zh: '幹父之蠱. 用譽.',
        ko: '간부지고. 용예.',
      },
      '4효': {
        zh: '裕父之蠱. 往見吝.',
        ko: '유부지고. 왕견린.',
      },
      '3효': {
        zh: '幹父之蠱. 小有悔, 無大咎.',
        ko: '간부지고. 소유회, 무대구.',
      },
      '2효': {
        zh: '幹母之蠱. 不可貞.',
        ko: '간모지고, 불가정.',
      },
      초효: {
        zh: '幹父之蠱. 有子, 考無咎. 厲終吉.',
        ko: '간부지고. 유자, 고무구. 려종길.',
      },
    },
  },
  {
    index: 19,
    name_ko: '지택임',
    name_zh: '地澤臨',
    gua: {
      zh: '臨, 元亨利貞, 至于八月有凶.',
      ko: '임. 원형리정, 지우팔월유흉.',
    },
    lines: {
      상효: {
        zh: '敦臨. 吉, 无咎.',
        ko: '돈임. 길, 무구.',
      },
      '5효': {
        zh: '知臨. 大君之宜, 吉.',
        ko: '지임. 대군지의, 길.',
      },
      '4효': {
        zh: '至臨. 无咎.',
        ko: '지임. 무구.',
      },
      '3효': {
        zh: '甘臨. 无攸利. 旣憂之, 无咎.',
        ko: '감임. 무유리. 기우지, 무구.',
      },
      '2효': {
        zh: '咸臨. 吉无不利.',
        ko: '함임. 길무불리.',
      },
      초효: {
        zh: '咸臨. 貞吉.',
        ko: '함임. 정길.',
      },
    },
  },
  {
    index: 20,
    name_ko: '풍지관',
    name_zh: '風地觀',
    gua: {
      zh: '觀, 盥而不薦, 有孚顒若.',
      ko: '관, 관이불천, 유부옹약.',
    },
    lines: {
      상효: {
        zh: '觀其生, 君子无咎.',
        ko: '관기생, 군자무구.',
      },
      '5효': {
        zh: '觀我生, 君子无咎.',
        ko: '관아생, 군자무구.',
      },
      '4효': {
        zh: '觀國之光. 利用賓于王.',
        ko: '관국지광. 리용빈우왕.',
      },
      '3효': {
        zh: '觀我生, 進退.',
        ko: '관아생, 진퇴.',
      },
      '2효': {
        zh: '闚觀. 利女貞.',
        ko: '규관. 리녀정.',
      },
      초효: {
        zh: '童觀. 小人无咎, 君子吝.',
        ko: '동관, 소인무구, 군자린.',
      },
    },
  },
  {
    index: 21,
    name_ko: '화뢰서합',
    name_zh: '火雷噬嗑',
    gua: {
      zh: '噬嗑, 亨, 利用獄.',
      ko: '서합, 형, 리용옥.',
    },
    lines: {
      상효: {
        zh: '何校滅耳, 凶.',
        ko: '하교멸이, 흉.',
      },
      '5효': {
        zh: '噬乾肉, 得黃金, 貞厲, 无咎.',
        ko: '서건육, 득황금, 정려, 무구.',
      },
      '4효': {
        zh: '噬乾胏, 得金矢, 利艱貞, 吉.',
        ko: '서건자, 득금시, 리간정, 길.',
      },
      '3효': {
        zh: '噬腊肉, 遇毒, 小吝, 无咎.',
        ko: '서석육, 우독, 소린, 무구.',
      },
      '2효': {
        zh: '噬膚, 滅鼻, 无咎.',
        ko: '서부, 멸비, 무구.',
      },
      초효: {
        zh: '屨校滅趾, 无咎.',
        ko: '구교멸지, 무구.',
      },
    },
  },
  {
    index: 22,
    name_ko: '산화분',
    name_zh: '山火賁',
    gua: {
      zh: '賁, 亨. 小利有攸往.',
      ko: '분, 형. 소리유유왕.',
    },
    lines: {
      상효: {
        zh: '白賁, 无咎.',
        ko: '백분, 무구.',
      },
      '5효': {
        zh: '賁于丘園, 束帛戔戔, 吝, 終吉.',
        ko: '분우구원, 속백전전, 린, 종길.',
      },
      '4효': {
        zh: '賁如, 皤如. 白馬翰如. 匪寇婚媾.',
        ko: '분여, 파여. 백마한여. 비구혼구.',
      },
      '3효': {
        zh: '賁如, 濡如, 永貞吉.',
        ko: '분여, 유여, 영정길.',
      },
      '2효': {
        zh: '賁其須.',
        ko: '분기수.',
      },
      초효: {
        zh: '賁其趾, 舍車而徒.',
        ko: '분기지, 사차이도.',
      },
    },
  },
  {
    index: 23,
    name_ko: '산지박',
    name_zh: '山地剝',
    gua: {
      zh: '剝, 不利有攸往.',
      ko: '박, 불리유유왕.',
    },
    lines: {
      상효: {
        zh: '碩果不食, 君子得輿, 小人剝廬.',
        ko: '석과불식, 군자득여, 소인박려.',
      },
      '5효': {
        zh: '貫魚以宮人寵, 无不利.',
        ko: '관어이궁인총, 무불리.',
      },
      '4효': {
        zh: '剝牀以膚, 凶.',
        ko: '박상이부, 흉.',
      },
      '3효': {
        zh: '剝之, 无咎.',
        ko: '박지, 무구.',
      },
      '2효': {
        zh: '剝牀以辨蔑, 貞凶.',
        ko: '박상이변멸, 정흉.',
      },
      초효: {
        zh: '剝牀以足蔑, 貞凶.',
        ko: '박상이족멸, 정흉.',
      },
    },
  },
  {
    index: 24,
    name_ko: '지뢰복',
    name_zh: '地雷復',
    gua: {
      zh: '復, 亨. 出入无疾, 朋來无咎, 反復其道, 七日來復. 利有攸往.',
      ko: '복, 형. 출입무질, 붕래무구, 반복기도, 칠일래복. 리유유왕.',
    },
    lines: {
      상효: {
        zh: '迷復, 凶. 有災眚. 用行師, 終有大敗, 以其國君凶. 至于十年不克征.',
        ko: '미복, 흉, 유재생, 용행사, 종유대패, 이기국군흉. 지우십년불극정.',
      },
      '5효': {
        zh: '敦復, 无悔.',
        ko: '돈복, 무회.',
      },
      '4효': {
        zh: '中行獨復.',
        ko: '중행독복.',
      },
      '3효': {
        zh: '頻復, 厲无咎.',
        ko: '빈복, 려무구.',
      },
      '2효': {
        zh: '休復, 吉.',
        ko: '휴복, 길.',
      },
      초효: {
        zh: '不遠復, 无祗悔, 元吉.',
        ko: '불원복, 무지회, 원길.',
      },
    },
  },
  {
    index: 25,
    name_ko: '천뢰무망',
    name_zh: '天雷无妄',
    gua: {
      zh: '无妄, 元亨利貞. 其匪正有眚, 不利有攸往.',
      ko: '무망, 원형리정. 기비정유생, 불리유유왕.',
    },
    lines: {
      상효: {
        zh: '无妄行, 有眚. 无攸利.',
        ko: '무망행, 유생. 무유리.',
      },
      '5효': {
        zh: '无妄之疾, 勿藥有喜.',
        ko: '무망지질, 물약유희.',
      },
      '4효': {
        zh: '可貞, 无咎.',
        ko: '가정, 무구.',
      },
      '3효': {
        zh: '无妄之災, 或繫之牛, 行人之得, 邑人之災.',
        ko: '무망지재, 혹계지우, 행인지득, 읍인지재.',
      },
      '2효': {
        zh: '不耕穫, 不菑畬, 則利有攸往.',
        ko: '불경확, 불치여, 즉리유유왕.',
      },
      초효: {
        zh: '无妄往, 吉.',
        ko: '무망왕, 길.',
      },
    },
  },
  {
    index: 26,
    name_ko: '산천대축',
    name_zh: '山天大畜',
    gua: {
      zh: '大畜, 利貞, 不家食吉, 利涉大川.',
      ko: '대축, 리정, 불가식길, 리섭대천.',
    },
    lines: {
      상효: {
        zh: '何天之衢, 亨.',
        ko: '하천지구, 형.',
      },
      '5효': {
        zh: '豶豕之牙, 吉.',
        ko: '분시지아, 길.',
      },
      '4효': {
        zh: '童牛之牿, 元吉.',
        ko: '동우지곡, 원길.',
      },
      '3효': {
        zh: '良馬逐, 利艱貞, 曰閑輿衛, 利有攸往.',
        ko: '양마축, 리간정, 왈한여위, 리유유왕.',
      },
      '2효': {
        zh: '輿說輹.',
        ko: '여탈복.',
      },
      초효: {
        zh: '有厲, 利已.',
        ko: '유려, 리이.',
      },
    },
  },
  {
    index: 27,
    name_ko: '산뢰이',
    name_zh: '山雷頤',
    gua: {
      zh: '頤, 貞吉. 觀頤, 自求口實.',
      ko: '이, 정길. 관이, 자구구실.',
    },
    lines: {
      상효: {
        zh: '由頤, 厲吉. 利涉大川.',
        ko: '유이, 려길. 리섭대천.',
      },
      '5효': {
        zh: '拂經, 居貞吉. 不可涉大川.',
        ko: '불경, 거정길. 불가섭대천.',
      },
      '4효': {
        zh: '顚頤, 吉. 虎視耽耽, 其欲逐逐, 无咎.',
        ko: '전이, 길. 호시탐탐, 기욕축축, 무구.',
      },
      '3효': {
        zh: '拂頤, 貞凶. 十年勿用, 无攸利.',
        ko: '불이, 정흉. 십년물용, 무유리.',
      },
      '2효': {
        zh: '顚頤, 拂經. 于丘頤, 征凶.',
        ko: '전이, 불경. 우구이, 정흉.',
      },
      초효: {
        zh: '舍爾靈龜, 觀我朶頤, 凶.',
        ko: '사이영귀, 관아타이, 흉.',
      },
    },
  },
  {
    index: 28,
    name_ko: '택풍대과',
    name_zh: '澤風大過',
    gua: {
      zh: '大過, 棟撓. 利有攸往, 亨.',
      ko: '대과, 동요. 리유유왕, 형.',
    },
    lines: {
      상효: {
        zh: '過涉滅頂. 凶, 无咎.',
        ko: '과섭멸정. 흉, 무구.',
      },
      '5효': {
        zh: '枯楊生華, 老婦得其士夫, 无咎无譽.',
        ko: '고양생화, 노부득기사부, 무구무예.',
      },
      '4효': {
        zh: '棟隆, 吉. 有它吝.',
        ko: '동륭, 길. 유타린.',
      },
      '3효': {
        zh: '棟橈, 凶.',
        ko: '동요, 흉.',
      },
      '2효': {
        zh: '枯楊生稊, 老夫得其女妻, 无不利.',
        ko: '고양생제, 노부득기녀처, 무불리.',
      },
      초효: {
        zh: '藉用白茅, 无咎.',
        ko: '자용백모, 무구.',
      },
    },
  },
  {
    index: 29,
    name_ko: '중수감',
    name_zh: '重水坎',
    gua: {
      zh: '習坎. 有孚, 維心亨, 行有尙.',
      ko: '습감. 유부, 유심형, 행유상.',
    },
    lines: {
      상효: {
        zh: '係用徽纆, 寘于叢棘, 三歲不得, 凶.',
        ko: '계용휘묵, 진우총자, 삼세부득, 흉.',
      },
      '5효': {
        zh: '坎不盈, 祗旣平, 无咎.',
        ko: '감불영, 지이평, 무구.',
      },
      '4효': {
        zh: '樽酒, 簋貳, 用缶. 納約自牖, 終无咎.',
        ko: '준주, 궤이, 용부. 납약자유, 종무구.',
      },
      '3효': {
        zh: '來之坎坎, 險且枕. 入于坎窞, 勿用.',
        ko: '래지감감, 험차침. 입우감담, 물용.',
      },
      '2효': {
        zh: '坎有險, 求小得.',
        ko: '감유험, 구소득.',
      },
      초효: {
        zh: '習坎, 入于坎窞, 凶.',
        ko: '습감, 입우감담, 흉.',
      },
    },
  },
  {
    index: 30,
    name_ko: '중화리',
    name_zh: '重火離',
    gua: {
      zh: '離, 利貞. 亨. 畜牝牛吉.',
      ko: '리, 리정. 형. 축빈우길.',
    },
    lines: {
      상효: {
        zh: '王用出征, 有嘉 折首獲匪其醜, 无咎.',
        ko: '왕용출정, 유가 절수획비기추, 무구',
      },
      '5효': {
        zh: '出涕沱若, 戚嗟若, 吉.',
        ko: '출체타약, 척차약, 길',
      },
      '4효': {
        zh: '突如其來如, 焚如, 死如, 棄如.',
        ko: '돌여기래여, 분여, 사여, 기여',
      },
      '3효': {
        zh: '日昃之離, 不鼓缶而歌, 則大耋之嗟, 凶.',
        ko: '일측지리, 불고부이가, 즉대질지차, 흉',
      },
      '2효': {
        zh: '黃離, 元吉.',
        ko: '황리, 원길',
      },
      초효: {
        zh: '履錯然, 敬之, 无咎.',
        ko: '리착연, 경지, 무구',
      },
    },
  },
  {
    index: 31,
    name_ko: '택산함',
    name_zh: '澤山咸',
    gua: {
      zh: '咸, 亨, 利貞. 取女吉.',
      ko: '함, 형, 리정. 취녀길.',
    },
    lines: {
      상효: {
        zh: '咸其輔頰舌.',
        ko: '함기보협설.',
      },
      '5효': {
        zh: '咸其脢, 无悔.',
        ko: '함기매, 무회.',
      },
      '4효': {
        zh: '貞吉, 悔亡, 憧憧往來, 朋從爾思.',
        ko: '정길, 회망, 동동왕래, 붕종이사.',
      },
      '3효': {
        zh: '咸其股, 執其隨, 往吝.',
        ko: '함기고, 집기수, 왕린.',
      },
      '2효': {
        zh: '咸其腓, 凶, 居吉.',
        ko: '함기비, 흉. 거길.',
      },
      초효: {
        zh: '咸其拇.',
        ko: '함기무.',
      },
    },
  },
  {
    index: 32,
    name_ko: '뇌풍항',
    name_zh: '雷風恒',
    gua: {
      zh: '恒, 亨, 无咎, 利貞, 利有攸往.',
      ko: '항, 형, 무구, 리정, 리유유왕.',
    },
    lines: {
      상효: {
        zh: '振恒, 凶.',
        ko: '진항, 흉.',
      },
      '5효': {
        zh: '恒其德, 貞, 婦人吉, 夫子凶.',
        ko: '항기덕, 정, 부인길, 부자흉.',
      },
      '4효': {
        zh: '田无禽.',
        ko: '전무금.',
      },
      '3효': {
        zh: '不恒其德, 或承之羞, 貞吝.',
        ko: '불항기덕, 혹승지수, 정린.',
      },
      '2효': {
        zh: '悔亡.',
        ko: '회망.',
      },
      초효: {
        zh: '浚恒, 貞凶, 无攸利.',
        ko: '준항, 정흉, 무유리.',
      },
    },
  },
  {
    index: 33,
    name_ko: '천산둔',
    name_zh: '天山遯',
    gua: {
      zh: '遯, 亨小, 利貞.',
      ko: '둔, 형소, 리정.',
    },
    lines: {
      상효: {
        zh: '肥遯, 无不利.',
        ko: '비둔, 무불리.',
      },
      '5효': {
        zh: '嘉遯, 貞吉.',
        ko: '가둔, 정길.',
      },
      '4효': {
        zh: '好遯, 君子吉, 小人否.',
        ko: '호둔, 군자길, 소인비.',
      },
      '3효': {
        zh: '係遯. 有疾, 厲. 畜臣妾, 吉.',
        ko: '계둔. 유질, 려. 축신첩, 길.',
      },
      '2효': {
        zh: '執之用黃牛之革, 莫之勝說.',
        ko: '집지용황우지혁, 막지승탈.',
      },
      초효: {
        zh: '遯尾, 厲. 勿用有攸往.',
        ko: '둔미, 려. 물용유유왕.',
      },
    },
  },
  {
    index: 34,
    name_ko: '뇌천대장',
    name_zh: '雷天大壯',
    gua: {
      zh: '大壯, 利貞.',
      ko: '대장, 리정.',
    },
    lines: {
      상효: {
        zh: '羝羊觸藩, 不能退, 不能遂, 无攸利, 艱則吉.',
        ko: '저양촉번, 불능퇴, 불능수, 무유리, 난즉길.',
      },
      '5효': {
        zh: '喪羊于易, 无悔.',
        ko: '상양우역, 무회.',
      },
      '4효': {
        zh: '貞吉, 悔亡, 藩決不羸, 壯于大輿之輹.',
        ko: '정길, 회망, 번결불리, 자우대여지복.',
      },
      '3효': {
        zh: '小人用壯, 君子用罔, 貞厲. 羝羊觸藩, 羸其角.',
        ko: '소아용장, 군자용망, 정려. 저양촉번, 리기각.',
      },
      '2효': {
        zh: '貞吉.',
        ko: '정길.',
      },
      초효: {
        zh: '壯于趾, 征凶, 有孚.',
        ko: '장우지, 정흉, 유부.',
      },
    },
  },
  {
    index: 35,
    name_ko: '화지진',
    name_zh: '火地晉',
    gua: {
      zh: '晉, 康侯用錫馬蕃庶, 晝日三接',
      ko: '진, 강후용석마번서, 주일삼접.',
    },
    lines: {
      상효: {
        zh: '晉其角, 維用伐邑. 厲, 吉无咎, 貞吝.',
        ko: '진기각, 유용벌읍. 려, 길무구. 정린.',
      },
      '5효': {
        zh: '悔亡, 失得勿恤, 往吉, 无不利.',
        ko: '회망, 실득물휼, 왕길, 무불리.',
      },
      '4효': {
        zh: '晉如鼫鼠, 貞厲.',
        ko: '진여석서, 정려.',
      },
      '3효': {
        zh: '衆允, 悔亡.',
        ko: '중윤, 회망.',
      },
      '2효': {
        zh: '晉如愁如, 貞吉, 受玆介福于其王母.',
        ko: '진여수여, 정길, 수자개복우기왕모.',
      },
      초효: {
        zh: '晉如摧如, 貞吉, 罔孚, 裕无咎.',
        ko: '진여최여, 정길, 망부, 유무구.',
      },
    },
  },
  {
    index: 36,
    name_ko: '지화명이',
    name_zh: '地火明夷',
    gua: {
      zh: '明夷, 利艱貞.',
      ko: '명이, 리간정.',
    },
    lines: {
      상효: {
        zh: '不明晦. 初登于天, 後入于地.',
        ko: '불명회. 초등우천, 후입우지.',
      },
      '5효': {
        zh: '箕子之明夷, 利貞.',
        ko: '기자지명이, 리정.',
      },
      '4효': {
        zh: '入于左腹, 獲明夷之心于出門庭.',
        ko: '입우좌복, 획명이지심우출문정.',
      },
      '3효': {
        zh: '明夷, 于南狩, 得其大首. 不可疾貞.',
        ko: '명이, 우남수, 득기대수. 불가질정.',
      },
      '2효': {
        zh: '明夷, 夷于左股, 用拯馬壯, 吉.',
        ko: '명이, 이우좌고, 용증마장, 길.',
      },
      초효: {
        zh: '明夷于飛, 垂其翼. 君子于行, 三日不食. 有攸往, 主人有言',
        ko: '명이우비, 수기익. 군자우행, 삼일불식. 유유왕, 주인유언',
      },
    },
  },
  {
    index: 37,
    name_ko: '풍화가인',
    name_zh: '風火家人',
    gua: {
      zh: '家人, 利女貞.',
      ko: '가인, 리녀정.',
    },
    lines: {
      상효: {
        zh: '有孚, 威如, 終吉.',
        ko: '유부, 위여, 종길.',
      },
      '5효': {
        zh: '王假有家, 勿恤, 吉.',
        ko: '왕격유가, 물휼, 길.',
      },
      '4효': {
        zh: '富家, 大吉.',
        ko: '부가, 대길.',
      },
      '3효': {
        zh: '家人嗃嗃, 悔厲, 吉, 婦子嘻嘻, 終吝.',
        ko: '가인학학, 회려, 길. 부자희희, 종린.',
      },
      '2효': {
        zh: '无攸遂, 在中饋, 貞吉.',
        ko: '무유수, 재중궤, 정길.',
      },
      초효: {
        zh: '閑有家, 悔亡.',
        ko: '한유가, 회망.',
      },
    },
  },
  {
    index: 38,
    name_ko: '화택규',
    name_zh: '火澤睽',
    gua: {
      zh: '睽, 小事吉.',
      ko: '규, 소사길.',
    },
    lines: {
      상효: {
        zh: '睽孤, 見豕負塗, 載鬼一車. 先張之弧, 後說之弧. 匪寇婚媾, 往遇雨則吉.',
        ko: '규고, 견시부도, 재귀일거, 선장지호, 후설지호, 비구혼구, 정우우즉길.',
      },
      '5효': {
        zh: '悔亡, 厥宗噬膚, 往何咎.',
        ko: '회망, 궐종서부, 왕하구.',
      },
      '4효': {
        zh: '睽孤, 遇元夫, 交孚, 厲无咎.',
        ko: '규고, 우원부, 교부, 려무구.',
      },
      '3효': {
        zh: '見輿曳, 其牛掣, 其人天且劓. 无初有終.',
        ko: '견여예, 기우체, 기인천차의. 무초유종.',
      },
      '2효': {
        zh: '遇主于巷, 无咎.',
        ko: '우주우항, 무구.',
      },
      초효: {
        zh: '悔亡, 喪馬, 勿逐自復. 見惡人, 无咎.',
        ko: '회망, 상마, 물축자복. 견악인, 무구.',
      },
    },
  },
  {
    index: 39,
    name_ko: '수산건',
    name_zh: '水山蹇',
    gua: {
      zh: '蹇, 利西南, 不利東北. 利見大人. 貞吉.',
      ko: '건, 리서남, 불리동북. 리견대인, 정길.',
    },
    lines: {
      상효: {
        zh: '往蹇, 來碩. 吉, 利見大人.',
        ko: '왕건, 래석. 길, 리견대인.',
      },
      '5효': {
        zh: '大蹇, 朋來.',
        ko: '대건, 붕래.',
      },
      '4효': {
        zh: '往蹇, 來連.',
        ko: '왕건, 래연.',
      },
      '3효': {
        zh: '往蹇, 來反.',
        ko: '왕건, 래반.',
      },
      '2효': {
        zh: '王臣蹇蹇, 匪躬之故.',
        ko: '왕신건건, 비궁지고.',
      },
      초효: {
        zh: '往蹇, 來譽.',
        ko: '왕건, 래예.',
      },
    },
  },
  {
    index: 40,
    name_ko: '뇌수해',
    name_zh: '雷水解',
    gua: {
      zh: '解, 利西南, 无所往, 其來復吉. 有攸往, 夙吉.',
      ko: '해, 리서남, 무소왕, 기래복길. 유유왕, 숙길.',
    },
    lines: {
      상효: {
        zh: '公用射隼于高墉之上, 獲之, 无不利.',
        ko: '공용사준우고담지상, 획지, 무불리.',
      },
      '5효': {
        zh: '君子維有解, 吉. 有孚于小人.',
        ko: '군자유유해, 길. 유부우소인.',
      },
      '4효': {
        zh: '解而拇, 朋至斯孚.',
        ko: '해이무, 붕지사부.',
      },
      '3효': {
        zh: '負且乘, 致寇至. 貞吝.',
        ko: '부차승, 치구지. 정린.',
      },
      '2효': {
        zh: '田獲三狐, 得黃失, 貞吉.',
        ko: '전획삼호, 득황시, 정길.',
      },
      초효: {
        zh: '无咎.',
        ko: '무구.',
      },
    },
  },
  {
    index: 41,
    name_ko: '산택손',
    name_zh: '山澤損',
    gua: {
      zh: '損, 有孚, 元吉, 无咎, 可貞, 利有攸往. 曷之用 二簋可用享.',
      ko: '손, 유부, 원길, 무구, 가정, 리유유왕. 갈지용 이궤가용향.',
    },
    lines: {
      상효: {
        zh: '弗損益之, 无咎, 貞吉. 有攸往, 得臣无家.',
        ko: '불손익지, 무구, 정길. 유유왕, 득신무가.',
      },
      '5효': {
        zh: '或益之十朋之龜, 弗克違, 元吉.',
        ko: '혹익지십붕지구, 불극위, 원길.',
      },
      '4효': {
        zh: '損其疾, 使遄有喜, 无咎.',
        ko: '손기질, 사천유희, 무구.',
      },
      '3효': {
        zh: '三人行, 則損一人. 一人行, 則得其友.',
        ko: '삼인행, 즉손일인. 일인행, 즉득기우.',
      },
      '2효': {
        zh: '利貞, 征凶. 弗損益之.',
        ko: '리정, 정흉. 불손익지.',
      },
      초효: {
        zh: '已事遄往, 无咎. 酌損之.',
        ko: '이사천왕, 무구. 작손지.',
      },
    },
  },
  {
    index: 42,
    name_ko: '풍뢰익',
    name_zh: '風雷益',
    gua: {
      zh: '益, 利有攸往, 利涉大川.',
      ko: '익, 리유유왕, 리섭대천.',
    },
    lines: {
      상효: {
        zh: '莫益之, 或擊之. 立心勿恒, 凶.',
        ko: '막익지, 혹격지. 입심물항, 흉.',
      },
      '5효': {
        zh: '有孚惠心, 勿問元吉. 有孚惠我德.',
        ko: '유부혜심, 물문원길. 유부혜아덕.',
      },
      '4효': {
        zh: '中行告公從, 利用爲依遷國.',
        ko: '중행고공종, 리용위의천국.',
      },
      '3효': {
        zh: '益之用凶事, 无咎. 有孚 中行告公用圭.',
        ko: '익지용흉사, 무구. 유부, 중행고공용규.',
      },
      '2효': {
        zh: '或益之十朋之龜, 弗克違, 永貞吉. 王用享于帝, 吉.',
        ko: '혹익지십붕지귀, 불극위, 영정길. 왕용향우제, 길.',
      },
      초효: {
        zh: '利用爲大作, 元吉, 无咎.',
        ko: '리용위대작, 원길, 무구.',
      },
    },
  },
  {
    index: 43,
    name_ko: '택천쾌',
    name_zh: '澤天夬',
    gua: {
      zh: '夬, 揚于王庭. 孚號 “有厲.” 告自邑, “不利卽戎, 利有攸往.”',
      ko: '쾌, 양우왕정. 부호 “유려.” 고자읍. “불리즉융, 리유유왕.”',
    },
    lines: {
      상효: {
        zh: '无號, 終有凶.',
        ko: '무호, 종유흉.',
      },
      '5효': {
        zh: '莧陸夬夬, 中行无咎.',
        ko: '현륙쾌쾌, 중행무구.',
      },
      '4효': {
        zh: '臀无膚, 其行次且. 牽羊悔亡, 聞言不信.',
        ko: '둔무부, 기행차조. 견양회망, 문언불신.',
      },
      '3효': {
        zh: '壯于頄, 有凶. 君子夬夬, 獨行遇雨, 若濡有慍, 无咎.',
        ko: '장우구, 유흉. 군자쾌쾌, 독행우우, 약유유온, 무구.',
      },
      '2효': {
        zh: '惕號莫夜. “有戎“. 勿恤.',
        ko: '척호모야. “유융”. 물휼.',
      },
      초효: {
        zh: '壯于前趾, 往不勝爲咎.',
        ko: '장우전지, 왕불승위구.',
      },
    },
  },
  {
    index: 44,
    name_ko: '천풍구',
    name_zh: '天風姤',
    gua: {
      zh: '姤, 女壯, 勿用取女.',
      ko: '구, 여장, 물용취녀.',
    },
    lines: {
      상효: {
        zh: '姤其角, 吝, 无咎.',
        ko: '구기각, 린, 무구.',
      },
      '5효': {
        zh: '以杞包瓜, 含章, 有隕自天.',
        ko: '이기포과, 함장, 유운자천.',
      },
      '4효': {
        zh: '包无魚, 起凶.',
        ko: '포무어, 기흉.',
      },
      '3효': {
        zh: '臀无膚, 其行次且. 厲, 无大咎.',
        ko: '둔무부, 기행차조. 려, 무대구.',
      },
      '2효': {
        zh: '包有魚, 无咎, 不利賓.',
        ko: '포유어, 무구, 불리빈.',
      },
      초효: {
        zh: '繫于金柅, 貞吉. 有攸往, 見凶, 羸豕孚蹢躅.',
        ko: '계우금니, 정길. 유유왕, 견흉, 리시부척촉.',
      },
    },
  },
  {
    index: 45,
    name_ko: '택지췌',
    name_zh: '澤地萃',
    gua: {
      zh: '萃, 亨. 王假有廟, 利見大人, 亨. 利貞. 用大牲吉, 利有攸往.',
      ko: '췌, 형. 왕격유묘, 리견대인. 형. 리정. 용대생길, 리유유왕.',
    },
    lines: {
      상효: {
        zh: '齎咨涕洟, 无咎.',
        ko: '제자체이, 무구.',
      },
      '5효': {
        zh: '萃有位, 无咎. 匪孚. 元永貞, 悔亡.',
        ko: '췌유위, 무구. 비부. 원영정, 회망.',
      },
      '4효': {
        zh: '大吉, 无咎.',
        ko: '대길, 무구.',
      },
      '3효': {
        zh: '萃如嗟如, 无攸利. 往无咎, 小吝.',
        ko: '췌여차여, 무유리. 왕무구, 소린.',
      },
      '2효': {
        zh: '引吉, 无咎. 孚乃利用禴.',
        ko: '인길, 무구. 부내리용약.',
      },
      초효: {
        zh: '有孚不終, 乃亂乃萃. 若號, 一握爲笑. 勿恤, 往无咎',
        ko: '유부불종, 내란내췌. 약호, 일악위소. 물휼, 왕무구.',
      },
    },
  },
  {
    index: 46,
    name_ko: '지풍승',
    name_zh: '地風升',
    gua: {
      zh: '升, 元亨. 用見大人. 勿恤, 南征吉.',
      ko: '승, 원형. 리견대인. 물휼, 남정길.',
    },
    lines: {
      상효: {
        zh: '冥升, 利于不息之貞.',
        ko: '명승, 리우불식지정.',
      },
      '5효': {
        zh: '貞吉, 升階.',
        ko: '정길, 승계.',
      },
      '4효': {
        zh: '王用亨于岐山. 吉, 无咎.',
        ko: '왕용향우기산. 길, 무구.',
      },
      '3효': {
        zh: '升虛邑.',
        ko: '승허읍.',
      },
      '2효': {
        zh: '孚乃利用禴, 无咎.',
        ko: '부내리용약, 무구.',
      },
      초효: {
        zh: '允升, 大吉.',
        ko: '윤승, 대길.',
      },
    },
  },
  {
    index: 47,
    name_ko: '택수곤',
    name_zh: '澤水困',
    gua: {
      zh: '困, 亨. 貞. 大人吉, 无咎. 有言不信.',
      ko: '곤, 형. 정. 대인길, 무구. 유언불신.',
    },
    lines: {
      상효: {
        zh: '困于葛藟于臲卼, 曰“動悔” 有悔. 征吉.',
        ko: '곤우갈류우얼올, 왈“동회” 유회. 정길.',
      },
      '5효': {
        zh: '劓刖, 困于赤紱, 乃徐有說, 利用祭祀.',
        ko: '의월, 곤우적불, 내서유탈, 리용제사.',
      },
      '4효': {
        zh: '來徐徐, 困于金車, 吝, 有終.',
        ko: '래서서, 곤우금차, 린, 유종.',
      },
      '3효': {
        zh: '困于石, 據于蒺蔾, 入于其宮, 不見其妻, 凶.',
        ko: '곤우석, 거우질려, 입우기궁, 불견기처, 흉.',
      },
      '2효': {
        zh: '困于酒食, 朱紱方來, 利用享祀, 征凶, 无咎.',
        ko: '곤우주식, 주불방래, 리용향사, 정흉, 무구.',
      },
      초효: {
        zh: '臀困于株木, 入于幽谷, 三歲不覿.',
        ko: '둔곤우주목, 입우유곡, 삼세불적.',
      },
    },
  },
  {
    index: 48,
    name_ko: '수풍정',
    name_zh: '水風井',
    gua: {
      zh: '井, 改邑 不改井. 无喪无得, 往來井井. 汔至 亦未繘井. 羸其甁, 凶.',
      ko: '정, 개읍 불개정. 무상무득, 왕래정정. 흘지 역미율정. 리기병, 흉.',
    },
    lines: {
      상효: {
        zh: '井收, 勿幕, 有孚, 元吉.',
        ko: '정수, 물막, 유부, 원길.',
      },
      '5효': {
        zh: '井洌, 寒泉食.',
        ko: '정렬, 한천식.',
      },
      '4효': {
        zh: '井甃, 无咎.',
        ko: '정추, 무구.',
      },
      '3효': {
        zh: '井渫不食, 爲我心惻, 可用汲, 王明並受其福.',
        ko: '정설불식, 위아심측, 가용급, 왕명병수기복.',
      },
      '2효': {
        zh: '井谷射鮒, 甕敝漏.',
        ko: '정곡사부, 옹폐루.',
      },
      초효: {
        zh: '井泥不食, 舊井无禽.',
        ko: '정니불식, 구정무금.',
      },
    },
  },
  {
    index: 49,
    name_ko: '택화혁',
    name_zh: '澤火革',
    gua: {
      zh: '革, 已日乃孚. 元亨利貞. 悔亡.',
      ko: '혁, 기일내부. 원형리정. 회망.',
    },
    lines: {
      상효: {
        zh: '君子豹變, 小人革面. 征凶. 居貞吉.',
        ko: '군자표변, 소인혁면. 정흉. 거정길.',
      },
      '5효': {
        zh: '大人虎變. 未占 有孚.',
        ko: '대인호변. 미점 유부.',
      },
      '4효': {
        zh: '悔亡, 有孚. 改命 吉.',
        ko: '회망, 유부. 개명 길.',
      },
      '3효': {
        zh: '征凶, 貞厲. 革言三就, 有孚.',
        ko: '정흉, 정려. 혁언삼취, 유부.',
      },
      '2효': {
        zh: '已日乃革之. 征吉無咎.',
        ko: '기일내혁지. 정길무구.',
      },
      초효: {
        zh: '鞏用黃牛之革.',
        ko: '공용황우지혁.',
      },
    },
  },
  {
    index: 50,
    name_ko: '화풍정',
    name_zh: '火風鼎',
    gua: {
      zh: '鼎, 元吉, 亨.',
      ko: '정, 원형, 길.',
    },
    lines: {
      상효: {
        zh: '鼎玉鉉, 大吉, 无不利.',
        ko: '정옥현, 대길, 무불리.',
      },
      '5효': {
        zh: '鼎黃耳金鉉, 利貞.',
        ko: '정황이금현, 리정.',
      },
      '4효': {
        zh: '鼎折足, 覆公餗, 其形渥, 凶.',
        ko: '정절족, 복공속, 기형악, 흉.',
      },
      '3효': {
        zh: '鼎耳革, 其行塞, 雉膏不食, 方雨虧悔, 終吉.',
        ko: '정이혁, 기행색, 치고불식, 방우휴회, 종길.',
      },
      '2효': {
        zh: '鼎有實, 我仇有疾, 不我能卽, 吉.',
        ko: '정유실, 아구유질, 불아능즉, 길.',
      },
      초효: {
        zh: '鼎顚趾, 利出否. 得妾 以其子无咎.',
        ko: '정전지, 리출비. 득첩 이기자무구.',
      },
    },
  },
  {
    index: 51,
    name_ko: '중뢰진',
    name_zh: '重雷震',
    gua: {
      zh: '震, 亨. 震來虩虩, 笑言啞啞, 震驚百里, 不喪匕鬯.',
      ko: '진, 형. 진래혁혁, 소언액액, 진경백리, 불상비창.',
    },
    lines: {
      상효: {
        zh: '震索索, 視矍矍, 征凶. 震不于其躬, 于其鄰, 无咎, 婚媾有言.',
        ko: '진소소, 시각각, 정흉, 진불우기궁, 우기린, 무구, 혼구유언.',
      },
      '5효': {
        zh: '震往來厲, 億无喪有事.',
        ko: '진왕래려, 억무상유사.',
      },
      '4효': {
        zh: '震遂泥.',
        ko: '진수니.',
      },
      '3효': {
        zh: '震蘇蘇, 震行无眚.',
        ko: '진소소, 진행무생.',
      },
      '2효': {
        zh: '震來厲, 億喪貝. 躋于九陵, 勿逐, 七日得.',
        ko: '진래려, 억상패. 제우구릉, 물추, 칠일득',
      },
      초효: {
        zh: '震來虩虩, 後笑言啞啞, 吉.',
        ko: '진래혁혁, 후소언액액, 길.',
      },
    },
  },
  {
    index: 52,
    name_ko: '중산간',
    name_zh: '重山艮',
    gua: {
      zh: '艮有背, 不獲其身, 行其庭, 不見其人. 无咎.',
      ko: '간유배, 불획기신, 행기정, 불견기인. 무구.',
    },
    lines: {
      상효: {
        zh: '敦艮, 吉.',
        ko: '돈간, 길.',
      },
      '5효': {
        zh: '艮其輔, 言有序, 悔亡.',
        ko: '간기보, 언유서, 회망.',
      },
      '4효': {
        zh: '艮其身, 无咎.',
        ko: '간기신, 무구',
      },
      '3효': {
        zh: '艮其限, 列其夤, 厲薰心.',
        ko: '간기한, 열기인, 려훈심',
      },
      '2효': {
        zh: '艮其腓, 不拯其隨, 其心不快.',
        ko: '간기비, 불증기수, 기심불쾌',
      },
      초효: {
        zh: '艮其趾, 无咎, 利永貞.',
        ko: '간기지, 무구, 리영정',
      },
    },
  },
  {
    index: 53,
    name_ko: '풍산점',
    name_zh: '風山漸',
    gua: {
      zh: '漸, 女歸吉. 利貞.',
      ko: '점, 여귀길. 리정.',
    },
    lines: {
      상효: {
        zh: '鴻漸于陸, 其羽可用爲儀, 吉.',
        ko: '홍점우륙, 기우가용위의, 길.',
      },
      '5효': {
        zh: '鴻漸于陵, 婦三歲不孕, 終莫之勝, 吉.',
        ko: '홍점우릉, 부삼세불잉, 종막지승, 길.',
      },
      '4효': {
        zh: '鴻漸于木, 或得其桷, 无咎.',
        ko: '홍점우목, 혹득기각, 무구.',
      },
      '3효': {
        zh: '鴻漸于陸, 夫征不復, 婦孕不育, 凶. 利禦寇.',
        ko: '홍점우륙, 부정불복, 부잉불육, 흉. 리어구.',
      },
      '2효': {
        zh: '鴻漸于磐, 飮食衎衎, 吉.',
        ko: '홍점우반, 음식가가, 길.',
      },
      초효: {
        zh: '鴻漸于干, 小子厲. 有言, 无咎.',
        ko: '홍점우간, 소자려. 유언, 무구.',
      },
    },
  },
  {
    index: 54,
    name_ko: '뇌택귀매',
    name_zh: '雷澤歸妹',
    gua: {
      zh: '歸妹, 征凶, 无攸利.',
      ko: '귀매, 정흉, 무유리.',
    },
    lines: {
      상효: {
        zh: '女承筐, 无實. 士刲羊, 无血. 无攸利.',
        ko: '여승광, 무실. 사규양, 무혈. 무유리.',
      },
      '5효': {
        zh: '帝乙歸妹, 其君之袂, 不如其娣之袂良, 月幾望, 吉.',
        ko: '제을귀매, 기군지몌, 불여기제지몌량, 월기망, 길.',
      },
      '4효': {
        zh: '歸妹愆期, 遲歸有時.',
        ko: '귀매건기, 지귀유시.',
      },
      '3효': {
        zh: '歸妹以須, 反歸以娣.',
        ko: '귀매이수, 반귀이제.',
      },
      '2효': {
        zh: '眇能視, 利幽人之貞.',
        ko: '묘능시, 리유인지정.',
      },
      초효: {
        zh: '歸妹以娣, 跛能履, 征吉.',
        ko: '귀매이제, 파능리, 정길.',
      },
    },
  },
  {
    index: 55,
    name_ko: '뇌화풍',
    name_zh: '雷火豐',
    gua: {
      zh: '豐, 亨. 王假之. 勿憂, 宜日中.',
      ko: '풍, 형. 왕격지. 물의, 의일중.',
    },
    lines: {
      상효: {
        zh: '豐其屋, 蔀其家. 闚其戶, 闃其无人. 三歲不覿, 凶.',
        ko: '풍기옥, 부기가. 규기호, 격기무인. 삼세불적, 흉.',
      },
      '5효': {
        zh: '來章, 有慶譽, 吉.',
        ko: '래장, 유경예, 길.',
      },
      '4효': {
        zh: '豐其蔀, 日中見斗. 遇其夷主, 吉.',
        ko: '풍기부, 일중견두. 우기이주, 길.',
      },
      '3효': {
        zh: '豐其沛, 日中見沬. 折其右肱, 无咎.',
        ko: '풍기폐, 일중견매. 절기우굉, 무구.',
      },
      '2효': {
        zh: '豐其蔀, 日中見斗. 往得疑疾, 有孚發若, 吉.',
        ko: '풍기부, 일중견두. 왕득의질, 유부발약, 길.',
      },
      초효: {
        zh: '遇其配主, 雖旬无咎, 往有尙.',
        ko: '우기배주, 수순무구, 왕유상.',
      },
    },
  },
  {
    index: 56,
    name_ko: '화산려',
    name_zh: '火山旅',
    gua: {
      zh: '旅, 小亨, 旅貞吉.',
      ko: '려, 소형. 려정길.',
    },
    lines: {
      상효: {
        zh: '鳥焚其巢, 旅人先笑後號咷, 喪牛于易, 凶.',
        ko: '조분기소, 려인선소후호도, 상우우역, 흉.',
      },
      '5효': {
        zh: '射雉, 一失亡, 終以譽命.',
        ko: '사치, 일시망, 종이예명.',
      },
      '4효': {
        zh: '旅于處, 得其資斧, 我心不快.',
        ko: '려우처, 득기자부, 아심불쾌.',
      },
      '3효': {
        zh: '旅焚其次, 喪其童僕, 貞厲.',
        ko: '려분기차, 상기동복, 정려.',
      },
      '2효': {
        zh: '旅卽次, 懷其資, 得童僕貞.',
        ko: '려즉차, 회기자, 득동복정.',
      },
      초효: {
        zh: '旅瑣瑣, 斯其所取災.',
        ko: '려쇄쇄, 사기소취재.',
      },
    },
  },
  {
    index: 57,
    name_ko: '중풍손',
    name_zh: '重風巽',
    gua: {
      zh: '巽, 小亨, 利有攸往, 利見大人.',
      ko: '손, 소형, 리유유왕, 리견대인.',
    },
    lines: {
      상효: {
        zh: '巽在牀下, 喪其資斧, 貞凶.',
        ko: '손재상하. 상기자부. 정흉.',
      },
      '5효': {
        zh: '貞吉悔亡, 无不利, 无初有終. 先庚三日後庚三日, 吉.',
        ko: '정길회망, 무불리, 무초유종, 선경삼일후경삼일, 길.',
      },
      '4효': {
        zh: '悔亡, 田獲三品.',
        ko: '회망, 전획삼품.',
      },
      '3효': {
        zh: '頻巽, 吝.',
        ko: '빈손, 린.',
      },
      '2효': {
        zh: '巽在牀下, 用史巫紛若. 吉, 无咎.',
        ko: '손재상하, 용사무분약. 길, 무구',
      },
      초효: {
        zh: '進退, 利武人之貞.',
        ko: '진퇴, 리무인지정.',
      },
    },
  },
  {
    index: 58,
    name_ko: '중택태',
    name_zh: '重澤兌',
    gua: {
      zh: '兌, 亨. 利貞.',
      ko: '태, 형. 리정.',
    },
    lines: {
      상효: {
        zh: '引兌.',
        ko: '인태.',
      },
      '5효': {
        zh: '孚于剝, 有厲.',
        ko: '부우박, 유려.',
      },
      '4효': {
        zh: '商兌未寧, 介疾有喜.',
        ko: '상태미녕, 개질유희.',
      },
      '3효': {
        zh: '來兌, 凶.',
        ko: '래태, 흉.',
      },
      '2효': {
        zh: '孚兌, 吉, 悔亡.',
        ko: '부태, 길, 회망.',
      },
      초효: {
        zh: '和兌, 吉.',
        ko: '화태, 길.',
      },
    },
  },
  {
    index: 59,
    name_ko: '풍수환',
    name_zh: '風水渙',
    gua: {
      zh: '渙, 亨. 王假有廟. 利涉大川. 利貞.',
      ko: '환, 형. 왕격유묘. 리섭대천. 리정.',
    },
    lines: {
      상효: {
        zh: '渙其血, 去逖出, 无咎.',
        ko: '환기혈, 거척출, 무구.',
      },
      '5효': {
        zh: '渙汗其大號. 渙王居, 无咎.',
        ko: '환한기대호. 환왕거, 무구.',
      },
      '4효': {
        zh: '渙其羣, 元吉. 渙有丘, 匪夷所思.',
        ko: '환기군, 원길. 환유구, 비이소사.',
      },
      '3효': {
        zh: '渙其躬, 无悔.',
        ko: '환기궁, 무회.',
      },
      '2효': {
        zh: '渙奔其机, 悔亡.',
        ko: '환분기궤, 회망.',
      },
      초효: {
        zh: '用拯馬壯吉.',
        ko: '용증마장길.',
      },
    },
  },
  {
    index: 60,
    name_ko: '수택절',
    name_zh: '水澤節',
    gua: {
      zh: '節, 亨. 苦節, 不可貞',
      ko: '절, 형. 고절, 불가정.',
    },
    lines: {
      상효: {
        zh: '苦節, 貞凶. 悔亡.',
        ko: '고절, 정흉. 회망.',
      },
      '5효': {
        zh: '甘節, 吉, 往有尙.',
        ko: '감절, 길. 왕유상.',
      },
      '4효': {
        zh: '安節, 亨.',
        ko: '안절, 형.',
      },
      '3효': {
        zh: '不節若, 則嗟若, 无咎.',
        ko: '불절약, 즉차약, 무구.',
      },
      '2효': {
        zh: '不出門庭, 凶.',
        ko: '불출문정, 흉.',
      },
      초효: {
        zh: '不出戶庭, 无咎.',
        ko: '불출호정, 무구.',
      },
    },
  },
  {
    index: 61,
    name_ko: '풍택중부',
    name_zh: '風澤中孚',
    gua: {
      zh: '中孚, 豚魚吉. 利涉大川, 利貞.',
      ko: '중부, 돈어길. 리섭대천, 리정.',
    },
    lines: {
      상효: {
        zh: '翰音登于天, 貞凶.',
        ko: '한음등우천, 정흉.',
      },
      '5효': {
        zh: '有孚攣如, 无咎.',
        ko: '유부연여, 무구.',
      },
      '4효': {
        zh: '月幾望, 馬匹亡, 无咎.',
        ko: '월기망, 마필망, 무구.',
      },
      '3효': {
        zh: '得敵, 或鼓或罷, 或泣或歌.',
        ko: '득적, 혹고혹파, 혹읍혹가.',
      },
      '2효': {
        zh: '鳴鶴在陰, 其子和之. 我有好爵, 吾與爾靡之.',
        ko: '명학재음, 기자화지. 아유호작, 오여이비지.',
      },
      초효: {
        zh: '虞吉, 有它不燕.',
        ko: '우길, 유타불연.',
      },
    },
  },
  {
    index: 62,
    name_ko: '뇌산소과',
    name_zh: '雷山小過',
    gua: {
      zh: '小過, 亨. 利貞. 可小事, 不可大事. 飛鳥遺之音, 不宜上. 宜下, 大吉.',
      ko: '소과, 형. 리정. 가소사, 불가대사. 비조유지음, 불의상. 의하, 대길.',
    },
    lines: {
      상효: {
        zh: '弗遇過之, 飛鳥離之, 凶. 是謂災眚.',
        ko: '불우과지, 비조리지, 흉. 시위재생.',
      },
      '5효': {
        zh: '密雲不雨, 自我西郊, 公弋取彼在穴.',
        ko: '밀운불우, 자아서교, 공익취피재혈.',
      },
      '4효': {
        zh: '无咎, 弗過遇之, 往厲必戒. “勿用, 永貞.“',
        ko: '무구, 불과우지, 왕려필계. “물용, 영정.”',
      },
      '3효': {
        zh: '弗過防之, 從或戕之, 凶.',
        ko: '불과방지, 종혹장지, 흉.',
      },
      '2효': {
        zh: '過其祖, 遇其妣, 不及其君, 遇其臣, 无咎.',
        ko: '과기조, 우기비. 불급기군, 우기신, 무구.',
      },
      초효: {
        zh: '飛鳥以凶.',
        ko: '비조이흉.',
      },
    },
  },
  {
    index: 63,
    name_ko: '수화기제',
    name_zh: '水火旣濟',
    gua: {
      zh: '旣濟, 亨小, 利貞, 初吉終亂',
      ko: '기제, 형소, 리정, 초길종란.',
    },
    lines: {
      상효: {
        zh: '濡其首, 厲.',
        ko: '유기수, 려.',
      },
      '5효': {
        zh: '東鄰殺牛, 不如西鄰之禴祭, 實受其福.',
        ko: '동린살우, 불여서린지약제, 실수기복.',
      },
      '4효': {
        zh: '繻有衣袽, 終日戒.',
        ko: '유유의여, 종일계.',
      },
      '3효': {
        zh: '高宗伐鬼方, 三年克之, 小人勿用.',
        ko: '고종벌귀방, 삼년극지, 소인물용.',
      },
      '2효': {
        zh: '婦喪其茀, 勿逐, 七日得.',
        ko: '부상기불, 물추, 칠일득.',
      },
      초효: {
        zh: '曳其輪, 濡其尾, 无咎.',
        ko: '예기륜, 유기미, 무구.',
      },
    },
  },
  {
    index: 64,
    name_ko: '화수미제',
    name_zh: '火水未濟',
    gua: {
      zh: '未濟, 亨小. 狐汔濟, 濡其尾, 无攸利.',
      ko: '미제, 형소. 호흘제, 유기미, 무유리.',
    },
    lines: {
      상효: {
        zh: '有孚于飮酒, 无咎. 濡其首, “有孚”失是.',
        ko: '유부우음주, 무구. 유기수, “유부”실시.',
      },
      '5효': {
        zh: '貞吉, 无悔. 君子之光, 有孚吉.',
        ko: '정길, 무회. 군자지광, 유부길.',
      },
      '4효': {
        zh: '貞吉, 悔亡. 震用伐鬼方, 三年有賞于大國.',
        ko: '정길, 회망. 진용벌귀방, 삼년유상우대국.',
      },
      '3효': {
        zh: '未濟, 征凶. 利涉大川.',
        ko: '미제, 정흉. 리섭대천.',
      },
      '2효': {
        zh: '曳其輪, 貞吉.',
        ko: '예기륜, 정길.',
      },
      초효: {
        zh: '濡其尾, 吝.',
        ko: '유기미, 린.',
      },
    },
  },
]
